import { createRoot } from 'react-dom/client'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import React from 'react'
import App from 'containers/app/App'
import Constants from 'Constants'
// eslint-disable-next-line import/no-extraneous-dependencies
import { LicenseInfo } from '@mui/x-license'

import reportWebVitals from './reportWebVitals'
import './index.css'

const container = document.getElementById('root')
const root = createRoot(container)

const { LAUNCH_DARKLY_CLIENT_SIDE_ID, MUI_X_LICENSE_KEY } = Constants

// react-beautiful-dnd is unmaintained and its droppable registry trips an
// invariant under React 18 StrictMode's double-mount cycle. The library exposes
// this flag to silence the dev-only warning (production already strips it).
window['__react-beautiful-dnd-disable-dev-warnings'] = true

// A deploy replaces the content-hashed chunks, so a tab holding a stale index.html
// 404s on lazy routes. Reload to pick up the fresh index.html instead of rendering
// nothing — at most once a minute, in case the reload lands on a stale copy too.
window.addEventListener('vite:preloadError', event => {
  const lastReloadAt = Number(sessionStorage.getItem('chunkPreloadErrorReloadAt')) || 0
  if (Date.now() - lastReloadAt < 60_000) return
  sessionStorage.setItem('chunkPreloadErrorReloadAt', String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

LicenseInfo.setLicenseKey(MUI_X_LICENSE_KEY)
;(async () => {
  const LDProvider = await asyncWithLDProvider({ clientSideID: LAUNCH_DARKLY_CLIENT_SIDE_ID })

  root.render(
    <React.StrictMode>
      <LDProvider>
        <App />
      </LDProvider>
    </React.StrictMode>
  )
})()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
